import { useForm } from '@mantine/form'
import {
    Button,
    Flex,
    LoadingOverlay,
    Paper,
    PasswordInput,
} from '@mantine/core'
import { Link, useNavigate } from 'react-router-dom'
import {
    IRequestUpdateUserPassword,
    IResponseGetUserByID,
} from '@interfaces/api/IUser'
import User from '@api/User'

const FormEditUserPassword = ({
    aftersuccess,
    data,
}: {
    aftersuccess?: () => any
    data: IResponseGetUserByID
}) => {
    const form = useForm<IRequestUpdateUserPassword>({
        initialValues: {
            password: '',
            confirmpassword: '',
        },
    })
    const navigate = useNavigate()

    const { isLoading, onSubmit } = User.useUpdateUserPassword({
        user_id: data.user_id,
        form,
        aftersuccess: () => navigate('/users'),
    })

    return (
        <Paper pos='relative'>
            <LoadingOverlay visible={isLoading} overlayBlur={2} />
            <form onSubmit={onSubmit}>
                <Flex gap='sm' direction='column'>
                    <PasswordInput
                        withAsterisk
                        label='รหัสผ่าน'
                        placeholder='รหัสผ่าน'
                        {...form.getInputProps('password')}
                    />
                    <PasswordInput
                        withAsterisk
                        label='ยืนยันรหัสผ่าน'
                        placeholder='ยืนยันรหัสผ่าน'
                        {...form.getInputProps('confirmpassword')}
                    />

                    <Flex mt='md' justify='end' gap='sm'>
                        <Button
                            component={Link}
                            to='/users'
                            variant='default'
                            w='fit-content'
                        >
                            ยกเลิก
                        </Button>
                        <Button type='submit' w='fit-content'>
                            บันทึกการแก้ไขรหัสผ่าน
                        </Button>
                    </Flex>
                </Flex>
            </form>
        </Paper>
    )
}

export default FormEditUserPassword
